export const COPYRIGHT = [
  'clCopyrightFooter_au',
  'clCopyrightFooter_nz'
]

export const LEADGEN_COPYRIGHT = [
  'clCopyrightshort_au',
  'clCopyrightShort_nz'
]
